import React from "react";
const Preset5 = () => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "112",
      height: "112",
      viewBox: "0 0 112 112",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("rect", { x: "8", y: "40", width: "32", height: "32", rx: "4", fill: "url(#paint0_linear_6001_4886)" }),
    /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "50", r: "4", fill: "white" }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M14.9565 58.8163L8 65.7551V68C8 70.2091 9.79086 72 12 72H36C38.2091 72 40 70.2091 40 68V62.2857L32.6957 55L21.913 65.7551L14.9565 58.8163Z",
        fill: "url(#paint1_linear_6001_4886)"
      }
    ),
    /* @__PURE__ */ React.createElement("rect", { x: "46", y: "64", width: "16", height: "8", rx: "2", fill: "#116DFF" }),
    /* @__PURE__ */ React.createElement("rect", { x: "46", y: "51", width: "28", height: "3", rx: "1.5", fill: "#868AA5" }),
    /* @__PURE__ */ React.createElement("rect", { x: "46", y: "56", width: "3", height: "3", rx: "1.5", fill: "#000624", fillOpacity: "0.3" }),
    /* @__PURE__ */ React.createElement("rect", { x: "50", y: "56", width: "9", height: "3", rx: "1.5", fill: "#000624", fillOpacity: "0.3" }),
    /* @__PURE__ */ React.createElement("rect", { x: "46", y: "40", width: "20", height: "6", rx: "3", fill: "#000624" }),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint0_linear_6001_4886",
        x1: "24",
        y1: "40",
        x2: "24",
        y2: "72",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ), /* @__PURE__ */ React.createElement(
      "linearGradient",
      {
        id: "paint1_linear_6001_4886",
        x1: "24",
        y1: "55",
        x2: "24",
        y2: "72",
        gradientUnits: "userSpaceOnUse"
      },
      /* @__PURE__ */ React.createElement("stop", { stopColor: "#E7F0FF" }),
      /* @__PURE__ */ React.createElement("stop", { offset: "1", stopColor: "#A8CAFF" })
    ))
  );
};
export {
  Preset5
};
//# sourceMappingURL=Preset5.js.map
